import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    if(window.location.href.indexOf("privacy-policy")>-1){
      
      this.router.navigate(['privacy-policy'])
    
    }else if(window.location.href.indexOf("delete-account")>-1){
      this.router.navigate(['delete-account'])
    }
    else if(localStorage.getItem("connceted")){ 
      this.router.navigate(['dashboard/analytics'])
    }else{
      this.router.navigate(['auth/signin'])
    }
  }
}
